/* This file is autogenerated, see readme.md for instructions */
import ImpactDownSvgIcon from '@bloomreach/banana-theme/icons/impact-down.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ImpactDownIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ImpactDownSvgIcon />
    </Icon>
  );
});

ImpactDownIcon.displayName = 'ImpactDownIcon';

export default ImpactDownIcon;
